import React, { useEffect, useState } from 'react';

import HookSelectFormControl from '../HookSelectFormControl';

import ParticipantsService from 'services/ParticipantsService';

import useResources from 'hooks/useResources';

const HookSuffixFormControl = (props: any) => {
    const [suffixes, setSuffixes] = useState([] as any[]);

    const { t } = useResources();

    useEffect(() => {
        setSuffixes(ParticipantsService.getSuffixes());
    }, []);

    return (
        <HookSelectFormControl
            {...props}
            items={[...suffixes.map((s) => ({ value: s.value, title: s.display }))]}
            addEmptyItem={true}
            emptyItemTitle={t(`ui.selectPlaceHolder.suffix`)}
        />
    );
};

export default HookSuffixFormControl;
